export default __webpack_public_path__ + "static/media/410.65d49b69.jpg";